export enum ReportsColumns {
  NAME = "name",
  BANK_ACCOUNT = "bank_account",
  DATE_FROM = "date_from",
  REPORT_PERIOD = "report_period",
  DATE_TO = "date_to",
  STATUS = "status",
  FORMAT = "format",
  CREATED_AT = "created_at",
  ACTIONS = "actions",
}

export const all = Object.keys(ReportsColumns).filter((item) => {
  return isNaN(Number(item));
});
